// extracted by mini-css-extract-plugin
export default {"pay":"Pay_pay__XYTjT","payInfo":"Pay_payInfo__6Y8p0","payUnit":"Pay_payUnit__B99u4","orderInfo":"Pay_orderInfo__3LKoV","payButton":"Pay_payButton__0g7kG"};